<script>
  import { get } from "svelte/store";
  import TextButton from "@components/TextButton";
  import * as allowedQuestionsState from "@stores/features/allowed-questions";
  import * as authState from "@stores/auth";
  import * as globalState from "@stores/global";
  import * as paywallState from "@stores/features/paywall";
  import * as sheetsState from "@stores/sheets";
  import * as suggestedQuestionsState from "@stores/features/suggested-questions";

  const states = [
    ["Allowed questions", Object.entries(allowedQuestionsState)],
    ["Auth", Object.entries(authState)],
    ["Global", Object.entries(globalState)],
    ["Paywall", Object.entries(paywallState)],
    ["Sheets", Object.entries(sheetsState)],
    ["Suggested questions", Object.entries(suggestedQuestionsState)],
  ];

  let visible = false;

  $: buttonText = visible ? "Hide state" : "Show state";

  /**
   * Toggle visibility
   */
  function toggle() {
    visible = !visible;
  }
</script>

<style>
  .state-debugger {
    font-size: 1.6rem;
    height: 65px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    width: 150px;
    z-index: 999;
  }

  .state-debugger.visible {
    height: 100%;
    left: 0;
    transform: none;
    width: 100%;
  }

  .toggle {
    color: white;
    position: absolute;
    left: 50%;
    top: 2em;
    transform: translateX(-50%);
  }

  .state {
    --primary-color: black;
    background: white;
    bottom: 1em;
    color: black;
    font-size: 1.6rem;
    left: 1em;
    overflow: scroll;
    padding: 2em;
    position: absolute;
    right: 1em;
    top: 4em;
  }

  dl {
    margin: 1em 0;
  }

  dl dl {
    margin: 0;
  }

  dt {
    font-weight: bold;
  }

  dd dt {
    font-weight: semi-bold;
  }

  dd {
    margin: 0;
  }

  dd dt, dd dd {
    display: inline;
  }
</style>

<div class="state-debugger" class:visible>
  <div class="toggle"><TextButton on:click={toggle}>{buttonText}</TextButton></div>
  {#if visible}
    <div class="state">
      {#each states as [name, state]}
        <dl>
          <dt>{name}</dt>
          <dd>
            {#each state as [key, value]}
              {#if typeof value === "object"}
                <dl>
                  <dt>{key}: </dt>
                  {#if typeof get(value) === "object" && !(get(value) instanceof Element)}
                    <dd>{JSON.stringify(get(value))}</dd>
                  {:else}
                    <dd>{get(value)}</dd>
                  {/if}
                </dl>
              {/if}
            {/each}
          </dd>
        </dl>
      {/each}
    </div>
  {/if}
</div>
